import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

// Schema kiểm tra tính hợp lệ
const schema = yup.object().shape({
  email: yup.string().email("Email không hợp lệ.").required("Email là bắt buộc."),
  password: yup.string().required("Mật khẩu là bắt buộc."),
});

const LoginForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    console.log("Dữ liệu đăng nhập:", data);
    alert("Đăng nhập thành công!");
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h2>Đăng nhập</h2>
      
      <div>
        <label>Email:</label>
        <input {...register("email")} placeholder="Nhập email" />
        <p>{errors.email?.message}</p>
      </div>

      <div>
        <label>Mật khẩu:</label>
        <input {...register("password")} type="password" placeholder="Nhập mật khẩu" />
        <p>{errors.password?.message}</p>
      </div>

      <button type="submit">Đăng nhập</button>
    </form>
  );
};

export default LoginForm;
